<template>
  <div>
    <main id="app">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
  export default {
    name: 'app-main',
  };
</script>



// WEBPACK FOOTER //
// src/components/AppMain.vue